
























































































































































import BaseComponent from "@/asdcom/BaseComponent";
import { Component, Vue, Inject, Prop, Emit } from "vue-property-decorator";
import util from "@/lib/util";
import {
  IPagedAndSortedInputDto,
  PagedAndSortedInputDto
} from "@/asdcom/apiproxy/apiproxy.dto";
//import PageTemplate from "@/components/vcponlineok/PageTemplate.vue";
import {StaffSignalrService} from "@/asdcom/sinalR/staff-signalr.service";
import { GlobalEventNamesEnum } from "@/asdcom/global-events-service";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    //PageTemplate,
    //iview
  }
})
export default class PageTemplate extends BaseComponent {
  // @Prop({ type: Boolean, default: false })
  drawer?: boolean = true;
  mini?: boolean = true;

  // get buildInfo(){
  //   return this.$store.getters['asdcom/app/buildInfo'];
  // }
  async created() {
    const locales = abp.localization.values.OCVCApp;
    this.$appsvs.globalEventsService.onDashboardUpdate(this.refreshDashboardCounts());
  }

  async refreshDashboardCounts(){
    this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
  }

  async mounted(){
        abp.event.on('dashboard.update.received', message=>{
          abp.log.debug({"page-template on received message":message});
        });

  }

  handleSelect() {}

  async logout() {
    // const ret = await this.$store.dispatch("asdcom/app/logout");
    // if (!!ret) {
    //   util.abp.auth.clearToken();
    //   location.reload();
    // } else {
    //   sweetAlert("Error", "Failed to logout from server.", "error");
    // }
    this.$appsvs.tokenAuth.logOut().then(() => {
      location.reload();
    });
    // util.abp.auth.clearToken();
  }

  listView() {
    bus.$emit('returnToListView');
    this.refreshList();
  }
 
  refreshList() {
    bus.$emit('refreshList');
  }
}
